<template>
  <textarea ref="editor"></textarea>
</template>

<script>
export default {
  name: "SummernoteEditor",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      isUpdating: false,
    };
  },

  mounted() {
    const vm = this;

    $(this.$refs.editor).summernote({
      lang: "pt-BR",
      height: 300,
      toolbar: [
        ["style", ["bold", "italic", "underline"]],
        ["font", ["strikethrough"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["picture"]],
      ],
      callbacks: {
        onChange(contents) {
          vm.isUpdating = true;
          vm.$emit("input", contents);
          vm.$nextTick(() => {
            vm.isUpdating = false;
          });
        },
        onImageUpload(files) {
          const editor = $(vm.$refs.editor);

          editor.summernote("saveRange");

          const reader = new FileReader();

          reader.onload = (e) => {
            const img = document.createElement("img");
            img.src = e.target.result;

            img.style.padding = "10px";

            editor.summernote("restoreRange");

            editor.summernote("insertNode", img);
          };

          reader.readAsDataURL(files[0]);
        },
        onKeydown(e) {
          const editor = $(vm.$refs.editor);

          if (e.key === "Tab") {
            e.preventDefault();

            if (e.shiftKey) {
              editor.summernote("outdent");
            } else {
              editor.summernote("indent");
            }
          }

          const selection = window.getSelection();

          if (!selection.rangeCount) return;

          const range = selection.getRangeAt(0);
          const container = range.startContainer;

          if (e.key === " " && container.nodeType === 3) {
            const text = container.textContent;

            if (text === "*") {
              e.preventDefault();

              // limpa o *
              container.textContent = "";

              // transforma em lista
              editor.summernote("insertUnorderedList");
            }
          }
        },
      },
    });

    $(this.$refs.editor).summernote("code", this.value);
  },

  watch: {
    value(newValue) {
      if (this.isUpdating) return;

      const current = $(this.$refs.editor).summernote("code");

      if (current !== newValue) {
        $(this.$refs.editor).summernote("code", newValue);
      }
    },
  },

  beforeDestroy() {
    if ($(this.$refs.editor).next(".note-editor").length) {
      $(this.$refs.editor).summernote("destroy");
    }
  },
};
</script>
